import React from "react";
import Auth from '../utils/auth';
const auth = new Auth();

const buttonStyles = {
  fontSize: "13px",
  textAlign: "center",
  color: "#fff",
  outline: "none",
  padding: "12px 60px",
  boxShadow: "2px 5px 10px rgba(0,0,0,.1)",
  backgroundColor: "rgb(255, 178, 56)",
  borderRadius: "6px",
  letterSpacing: "1.5px",
};
const email ='';
const Login = class extends React.Component {
    state = {
        disabled: false,
        buttonText: "Login",
      };

  login(email) {
    //const type = {type: 'signup'};
    const email2 = {email: email};
    //console.log(email);
    auth.login(email2);
  }

  render() {
    
    return (
      <div>
        <button
          style={buttonStyles}
          onClick={event => this.login(email)}
          disabled={this.state.disabled}
        >
          {this.state.buttonText}
        </button>
      </div>
    );
  }
};

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.jsx